import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
    AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ArrowRight } from "lucide-react";

export function RenameTool({ onFix }) {
    const [oldT, setOldT] = useState("");
    const [newT, setNewT] = useState("");
    const [ratio, setRatio] = useState("1");
    const [confirm, setConfirm] = useState(false);
    const r = Number(ratio);
    const ok = oldT && newT && oldT !== newT && r > 0;
    const run = async () => {
        setConfirm(false);
        if (await onFix({ action: "rename", params: { old: oldT, new: newT, ratio: r }, confirmed: true })) { setOldT(""); setNewT(""); setRatio("1"); }
    };
    return (
        <Card className="p-4 space-y-3" data-testid="rename-tool">
            <div>
                <h2 className="font-heading text-base font-semibold">Rename a ticker</h2>
                <p className="text-xs text-muted-foreground">For a symbol change of the same holding (e.g. TOT → TTE), or a SPAC/merger share exchange (e.g. VMAC → ANGH). All past transactions, notes and tax rates move to the new ticker. With a ratio other than 1, share counts are multiplied and per-share prices divided, so every amount stays the same.</p>
            </div>
            <form onSubmit={(e) => { e.preventDefault(); setConfirm(true); }} className="flex items-center gap-2 flex-wrap">
                <Input value={oldT} onChange={(e) => setOldT(e.target.value.toUpperCase().trim())} placeholder="Old ticker" className="h-8 w-[130px] text-xs num uppercase" data-testid="rename-old-input" />
                <ArrowRight className="w-4 h-4 text-muted-foreground" />
                <Input value={newT} onChange={(e) => setNewT(e.target.value.toUpperCase().trim())} placeholder="New ticker" className="h-8 w-[130px] text-xs num uppercase" data-testid="rename-new-input" />
                <span className="text-xs text-muted-foreground">at</span>
                <Input value={ratio} onChange={(e) => setRatio(e.target.value)} className="h-8 w-[80px] text-xs num" title="New shares received per old share" data-testid="rename-ratio-input" />
                <span className="text-xs text-muted-foreground">new per old share</span>
                <Button type="submit" size="sm" className="h-8 text-xs" disabled={!ok} data-testid="rename-submit-btn">Rename</Button>
            </form>
            <AlertDialog open={confirm} onOpenChange={setConfirm}>
                <AlertDialogContent data-testid="rename-confirm-dialog">
                    <AlertDialogHeader>
                        <AlertDialogTitle>Rename {oldT} to {newT}?</AlertDialogTitle>
                        <AlertDialogDescription>Every {oldT} transaction, dividend, note and tax rate moves to {newT}{r !== 1 ? `, with ${r} ${newT} shares per ${oldT} share (amounts unchanged)` : ""}. The original ticker is kept on each transaction for reference.</AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel data-testid="rename-cancel">Cancel</AlertDialogCancel>
                        <AlertDialogAction onClick={run} data-testid="rename-confirm">Rename</AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </Card>
    );
}
